<h2 mat-dialog-title class="dialog-title">Zmień okres rozliczeniowy</h2>
<hr class="title-separator" />

<mat-dialog-content class="dialog-content">
    <div class="date-row">
        <mat-form-field class="date-field">
            <mat-label>od</mat-label>
            <input matInput [matDatepicker]="fromPicker" [(ngModel)]="periodFrom" />
            <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="date-field">
            <mat-label>do</mat-label>
            <input matInput [matDatepicker]="toPicker" [(ngModel)]="periodTo" />
            <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="quick-buttons">
        <button mat-stroked-button (click)="setQuickTo(10)">10 dni</button>
        <button mat-stroked-button (click)="setQuickTo(30)">30 dni</button>
        <button mat-stroked-button (click)="setQuickTo(60)">60 dni</button>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button matButton (click)="closeDialog()">Anuluj</button>
    <button mat-flat-button color="primary" cdkFocusInitial (click)="save()" [disabled]="!isValid()">Zapisz</button>
</mat-dialog-actions>
